import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Warning } from "../../../utils/models/input.interface"
import { ModalLoadingComponent } from "../components/loads/modal-loading/modal-loading.component";
import { NewModalConfirmationComponent } from "../components/common/new-modal-confirmation/new-modal-confirmation.component";
import { ToastrService } from "ngx-toastr";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { RRule } from 'rrule';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import { DecimalPipe } from "@angular/common";

/** * FU - 001 - Retorna a propriedade do status *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} propriedade do status *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = propertyObjWarning(warning)
 * result é igual a 'sucess'
 **/
export function propertyObjWarning(warning: Warning): string {
  let propertyWarning = 'default';
  if(warning.status === 'success'){
    propertyWarning = 'sucess';
  } else if(warning.status === 'error'){
    propertyWarning = 'error';
  } else if(warning.status === 'info'){
    propertyWarning = 'info';
  } else if(warning.status === 'alert'){
    propertyWarning = 'alert';
  } else if(warning.status === 'loading'){
    propertyWarning = 'loading';
  }
  return propertyWarning;
}

/** * FU - 002 - Retorna o item pelo status especifico *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} Retorna o icone em que o status está inserido *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = returnWarningIcon(warning)
 * result é igual a 'warning-sucess'
 **/
export function returnWarningIcon(warning: Warning): string {
  const porpertyIcon = propertyObjWarning(warning);
  const iconsWarning = {
    sucess: 'warning-sucess',
    error: 'warning-error',
    info: 'warning-circle-information',
    alert: 'warning-circle-alert',
    load: 'loading',
  };
  return iconsWarning[porpertyIcon] ? iconsWarning[porpertyIcon] : '';
}

/** * FU - 003 - Retorna a cor do texto da mensagem de erro *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} Retorna a cor em que o status está inserido *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = returnColorWarning(warning)
 * result é igual a { 'color': '#115F22' }
 **/
export function returnColorWarning(warning: Warning): object {
  const porpertyIcon = propertyObjWarning(warning);
  const warningColors = {
    sucess: { 'color': '#115F22' },
    error: { 'color': '#A80B00' },
    info: { 'color': '#1F52AB' },
    alert: { 'color': '#5F4407' },
    load: { 'color': '#102956' },
  };
  return warningColors[porpertyIcon] ? warningColors[porpertyIcon] : {};
}

/** * FU - 004 - Retorna o texto pelo status especifico *
 *
 * @param {Warning} warning - obj com a lista de status.
 * @returns {string} Retorna o texto em que o status está inserido *
 * @throws {  } null.
 *
 * @example
 * const warning: Warning = {
 *  sucess: { active: true, text: 'success' },
 *  error: null,
 *  info: null,
 *  alert: null,
 *  load: null
 * }
 * const result = returnTextWarning(warning)
 * result é igual a 'success'
 **/
export function returnTextWarning(warning: Warning): string {
  return warning.text;
}

export function heightSidenavMenu(): void {
  setTimeout(() => {
    const menusHeight = document.querySelectorAll('.js_heigth_menu_container'), navlist: any = document.querySelector('.js_navlist_menu_container');
    if (menusHeight && navlist) {
      let heightMenu = 0;
      menusHeight.forEach((item: any) => {
        heightMenu += item.clientHeight;
      })
      navlist.style.maxHeight = `calc(100vh - ${heightMenu + 40}px)`;
    }
  }, 300);
}

export function squareTooltip(color: string): string {
  return `<span style="color: ${color}">◼</span>`;
}

export function paddingTooltip(size: number = 1): string {
  return `<span style="color: transparent">${'a'.repeat(size)}</span>`;
}

export function lineTooltip(size: number = 1, dash = false): string {
  return `${(dash ? '-' : '_').repeat(size)}`;
}

export function modalLoading(dialog: MatDialog, newTitle?: string, description?: string): MatDialogRef<ModalLoadingComponent> {
  return dialog.open(ModalLoadingComponent, {
    autoFocus: true,
    disableClose: true,
    width: '500px',
    height: '348px',
    data: {
      disableClose: true,
      title: newTitle ? newTitle : 'Carregando',
      text: description ? description : 'Por favor espere alguns momentos'
    },
    panelClass: 'loading-modal'
  });
}

export function modalConfirmation(
  dialog: MatDialog, 
  title: string, 
  description: string, 
  icon: string, 
  showConfirmMessage?: boolean, 
  cancelButtonName?: string, 
  confirmButtonName?: string,
  warningMessage?: string,
  height?: string,
  width?: string
): MatDialogRef<NewModalConfirmationComponent> {
  return dialog.open(NewModalConfirmationComponent, {
    autoFocus: true,
    disableClose: true,
    width: width || '500px',
    height: height || '301px',
    data: {
      icon,
      title,
      description,
      showConfirmMessage,
      cancelButtonName,
      confirmButtonName,
      warningMessage
    },
    panelClass: 'confirmation-modal'
  });
}

export function remove3HoursOnDate(date: any) {
  const newDate = new Date(date)
  newDate.setHours(newDate.getHours() - 3)
  return newDate
}

export function formatStringDate(dateString) {
    const [year, month, day] = dateString.split("-"); // Split the date string into components
    return `${day}/${month}/${year}`;
}

export function formatLocalToISOString(date) {
  const pad = (n) => String(n).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
         `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function getDayMonth(date): string {
  const [dia, mes] = date.split('/');
  const mesesAbreviados = [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
    'jul', 'ago', 'set', 'out', 'nov', 'dez'
  ];
  const mesAbreviado = mesesAbreviados[parseInt(mes, 10) - 1]; // -1 porque o array começa em 0

  
  return`${dia}${mesAbreviado}`; 
}

export function formatIntervalDates(dataInicialStr, dataFinalStr) {
  dayjs.locale('pt-br');
  
  const dataInicial = dayjs(dataInicialStr.split('T')[0]);
  const dataFinal = dayjs(dataFinalStr.split('T')[0]);
  
  return `${dataInicial.date()} de ${dataInicial.format('MMMM')} a ${dataFinal.date()} de ${dataFinal.format('MMMM')}`
}

export function downloadSheet(blob: any, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName; // Define o nome do arquivo aqui
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export function downloadJSON(json: any, fileName: string) {
  const jsonString = JSON.stringify(json, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  
  a.href = url;
  a.download = fileName; // Define o nome do arquivo aqui
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
}

export function isFile(data) {
  return data instanceof File
}

export function handleSimulationError(dialog: any, interval: any, toastr: ToastrService, errorMessage?: string): void {
  cleanupAfterSimulation(dialog, interval);
  showErrorToast(errorMessage || 'Erro ao realizar a simulação.', toastr);
}

export function cleanupAfterSimulation(dialog: any, interval: any): void {
  dialog?.close();
  clearInterval(interval);
}

export function showErrorToast(message: string, toastr: ToastrService): void {
  toastr.show(message, 'Erro', { 
    messageClass: 'error'
  });
}

export function createUnavailabilities(data: any, dtStart: string) {
  const weekDays = {
    sunday: RRule.SU,
    monday: RRule.MO,
    tuesday: RRule.TU,
    wednesday: RRule.WE,
    thursday: RRule.TH,
    friday: RRule.FR,
    saturday: RRule.SA
  }
  const unavailabilities = [];

  data.forEach((res: any) => {
    if(res.recurrence.length > 0) {
      const start_date = new Date(`${dtStart}T${res.hourStart}:00`)
      start_date.setDate(start_date.getDate() - 180)

      const end_date = new Date(`${dtStart}T${res.hourEnd}:00`)
      end_date.setDate(end_date.getDate() + 180)
      
      const byweekday = res.recurrence.map(day => weekDays[day])

      const rule = new RRule({
        freq: RRule.WEEKLY,
        byweekday,
        dtstart: start_date,
        until: res?.date_recurrence ? new Date(res?.date_recurrence) : end_date
      })

      const event = rule.all().map(date => (
        {
          groupId: res.groupId,
          title: res.title,
          classNames: [res.type],
          type: res.type,
          extendedProps: {
            icon: 'refresh'
          },
          date_recurrence: res?.date_recurrence ? new Date(res?.date_recurrence) : null,
          recurrence: res.recurrence,
          start: formatLocalToISOString(new Date(date)),
          end: formatLocalToISOString(new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            new Date(end_date).getHours(), // Pega o horário final fixo
            new Date(end_date).getMinutes(),
            new Date(end_date).getSeconds()
          ))
        }
      ))

      unavailabilities.push(...event)
    } else {
      const event = {
        groupId: res.groupId,
        title: res.title,
        classNames: [res.type],
        type: res.type,
        recurrence: res.recurrence,
        start: formatLocalToISOString(new Date(res.date_time)),
        end: formatLocalToISOString(new Date(res.end_time))
      }

      unavailabilities.push(event)
    }
  })

  return unavailabilities
}

export function returnUnavailabilities(unavailabilities: any) {
  let newUnavailabilities = []
  const groupIds = [...new Set(unavailabilities.map(data => data.groupId))] 

  groupIds.forEach((id) => {
    const firstDataFromId = unavailabilities.find(data => data.groupId === id)
    if(firstDataFromId.recurrence.length > 0) {
      newUnavailabilities.push({
        title: firstDataFromId.title,
        groupId: id,
        type: firstDataFromId.type,
        date_recurrence: firstDataFromId?.date_recurrence || null,
        recurrence: firstDataFromId.recurrence,
        hourStart: firstDataFromId.start.split('T')[1].substring(0, 5),
        hourEnd: firstDataFromId.end.split('T')[1].substring(0, 5),
        date_time: null,
        end_time: null
      })
    } else {
      newUnavailabilities.push({
        title: firstDataFromId.title,
        groupId: id,
        type: firstDataFromId.type,
        recurrence: [],
        date_recurrence: null,
        hourStart: null,
        hourEnd: null,
        date_time: firstDataFromId.start,
        end_time: firstDataFromId.end
      })
    }
  })

  return newUnavailabilities
}

// CUSTOM VALIDATORS
export const dateRangeValidator: ValidatorFn = (control: AbstractControl) => {
  const start = control.get('start_time');
  const end = control.get('end_time');

  if (!start || !end || !start.value || !end.value) {
    return null;
  }

  const startDate = new Date(start.value);
  const endDate = new Date(end.value);

  return endDate >= startDate ? null : { dateRange: true };
};

export function numberValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const decimalPipe = new DecimalPipe('pt-BR');

    if (value === null || value === undefined || value === '') {
      return { requiredMsg: 'Campo obrigatório' };
    }

    if (typeof value !== 'number') {
      return { invalidType: 'O valor deve ser numérico' };
    }

    if (value < min) {
      return { underMin: `Valor menor que ${decimalPipe.transform(min , '1.0-0', 'pt-BR')}` };
    }

    if (value > max) {
      return { overMax: `Valor maior que ${decimalPipe.transform(max , '1.0-0', 'pt-BR')}` };
    }

    return null; // sem erros
  };
}

export function timeStringValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    
    // Se o valor estiver vazio, considerar válido (usar Validators.required se necessário)
    if (value === null || value === undefined || value === '') {
      return { required: 'Campo obrigatório' };
    }
    
    // Verificar o formato básico com regex
    if (!/^\d{1,2}:\d{2}$/.test(value)) {
      return { invalidFormat: 'Formato inválido. Use HH:mm' };
    }
    
    // Separar horas e minutos
    const [hoursStr, minutesStr] = value.split(':');
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    
    // Validar horas
    if (hours < 0 || hours > 23) {
      return { invalidHours: 'Horas devem estar entre 00 e 23' };
    }
    
    // Validar minutos
    if (minutes < 0 || minutes > 59) {
      return { invalidMinutes: 'Minutos devem estar entre 00 e 59' };
    }
    
    // Se tudo estiver correto
    return null;
  };
}